'use client';

import Script from 'next/script';
import { useEffect, useState } from 'react';

interface AxeptioScriptProps {
  domain: string;
}

const BUTTON_CSS = `
  #axeptio_main_button {
    position: fixed !important;
    bottom: 15px !important;
  }
`;

export const AxeptioScript = ({ domain }: AxeptioScriptProps) => {
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (window.location.hostname === domain) setShouldRender(true);
  }, [domain]);

  useEffect(() => {
    if (!shouldRender) return;

    const interval = setInterval(() => {
      const host = document.querySelector('.needsclick');
      const shadow = host?.shadowRoot;
      if (shadow && !shadow.querySelector('#axeptio-position-style')) {
        const style = document.createElement('style');
        style.id = 'axeptio-position-style';
        style.textContent = BUTTON_CSS;
        shadow.appendChild(style);
        clearInterval(interval);
      }
    }, 300);

    return () => clearInterval(interval);
  }, [shouldRender]);

  if (!shouldRender) return null;

  return (
    <Script id='axeptio-settings'>
      {`
        window.axeptioSettings = {
          clientId: "66e1485259bb6037f2b40b9b",
          cookiesVersion: "en-gb-11-09-2024",
          googleConsentMode: {
            default: {
              analytics_storage: "denied",
              ad_storage: "denied",
              ad_user_data: "denied",
              ad_personalization: "denied",
              wait_for_update: 500
            }
          }
        };

        (function(d, s) {
          var t = d.getElementsByTagName(s)[0], e = d.createElement(s);
          e.async = true; e.src = "//static.axept.io/sdk.js";
          t.parentNode.insertBefore(e, t);
        })(document, "script");
      `}
    </Script>
  );
};
